var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconHpLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 105,
    height: 51,
    viewBox: "0 0 105 51",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3294_17918)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M74.7411 25.5001C74.7411 13.098 64.7839 3.04507 52.4999 3.04507C52.165 3.04507 51.8318 3.05361 51.5002 3.06898L46.9509 15.693H50.9133C53.2704 15.693 54.5408 17.5255 53.7339 19.7636L48.1222 35.3336L43.4105 35.3327L49.4323 18.6441H45.8894L39.8676 35.3327H35.1541L42.2349 15.693H42.2357L46.495 3.87421C37.129 6.51959 30.2588 15.1995 30.2588 25.5001C30.2588 36.1064 37.5434 44.9946 47.3365 47.3454L51.4639 35.8937H51.4673L58.7485 15.693H67.4269C69.7866 15.693 71.0561 17.5255 70.2492 19.7636L65.3184 33.4388C64.9429 34.4805 63.7376 35.3327 62.6398 35.3327H56.3845L51.8394 47.9448C52.0584 47.9508 52.2792 47.9551 52.4999 47.9551C64.7839 47.9551 74.7411 37.9013 74.7411 25.5001Z",
    fill: "#0096D6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.9578 18.6322H62.4166L57.457 32.3706H60.9983L65.9578 18.6322Z",
    fill: "#0096D6"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3294_17918"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 44.5714,
    height: 45,
    fill: "white",
    transform: "translate(30.2144 3)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconHpLogo);
export default __webpack_public_path__ + "static/media/icon-hp-logo.cbd0f8cd6e84627ab9074378209f94d3.svg";
export { ForwardRef as ReactComponent };